import { getEnv } from '@/utils/env';

const BrandliveBackdrop = () => {
  const { VITE_ASSET_SERVER } = getEnv();
  return (
    <video
      className="video-garnish"
      preload="auto"
      autoPlay={true}
      muted={true}
      playsInline={true}
      disablePictureInPicture={true}
      loop={true}
    >
      <source src={`${VITE_ASSET_SERVER}/bl-platform/videos/intro_smaller_no_audio.mp4`} type="video/mp4" />
    </video>
  );
};

export default BrandliveBackdrop;
